import { Component, OnInit, AfterViewInit } from '@angular/core';

import { AdminService } from '../../../../shared/services/admin/admin.service';
import { LocalStorageService } from '../../../../shared/services/local-storage/local-storage.service';

import * as Chart from 'chart.js';
import * as moment from 'moment';
import { ContaService } from '../../../../shared/services/conta/conta.service';

@Component({
  selector: 'app-visao-geral',
  templateUrl: './visao-geral.component.html',
  styleUrls: ['./visao-geral.component.scss']
})
export class VisaoGeralComponent implements OnInit, AfterViewInit {
  public error = false;
  public success = false;

  public user: any = null;
  public account: any = null;
  public dashboardData: any = null;

  public monthTotal = { integer: null, decimal: null };
  public todayTotal = { integer: null, decimal: null };

  public payments = { firstMonth: null, secondMonth: null, thirdMonth: null, fourthMonth: null };
  public salesByPeriod = [];

  public months: string[] = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

  constructor(
    private contaService: ContaService,
    private adminService: AdminService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.getUser();
    this.getAccount();
  }

  getUser() {
    this.user = this.localStorageService.get('login');
  }

  getAccount() {
    this.contaService.obterConta(this.user.PersonId).subscribe((data) => {
      this.account = data;

      this.getDashboardInfo();
    }, (err) => {
      console.error(err);
    });
  }

  getDashboardInfo() {
    const initialDate = moment().subtract(5, 'months').format('YYYY/MM/DD');
    const finalDate = moment().format('YYYY/MM/DD');

    this.adminService.getDashboard(initialDate, finalDate, this.user.PersonId).subscribe((data) => {
      this.success = true;
      this.dashboardData = data;

      this.setDashboardValues();

      this.mountBarChart();
      this.mountAreaChart();
    }, (err) => {
      this.error = true;

      console.error(err);
    });
  }

  setDashboardValues() {
      const numberArrayToday = this.dashboardData.VendasHoje.ValorTotalHoje.toFixed(2).toString().split('.');
      const numberArrayMonth = this.dashboardData.VendasHoje.ValorTotalMes.toFixed(2).toString().split('.');

      this.todayTotal.integer = numberArrayToday[0];
      this.todayTotal.decimal = numberArrayToday[1];

      this.monthTotal.integer = numberArrayMonth[0];
      this.monthTotal.decimal = numberArrayMonth[1];

      this.payments.firstMonth = this.dashboardData.PagamentosRealizados.ValorTotal1M;
      this.payments.secondMonth = this.dashboardData.PagamentosRealizados.ValorTotal2M;
      this.payments.thirdMonth = this.dashboardData.PagamentosRealizados.ValorTotal3M;
      this.payments.fourthMonth = this.dashboardData.PagamentosRealizados.ValorTotal4M;

      this.dashboardData.VendasPorPeriodo.Itens.forEach((item) => {
        this.salesByPeriod.push(item.ValorTotal);
      });
  }

  mountAreaChart() {
    const areaChart: any = document.getElementById('area-chart');

    if (!areaChart) { return; }

    const labels: any[] = [];

    this.salesByPeriod.forEach((total, i) => {
      labels.push(this.months[new Date().getMonth() - i]);
    });

    labels.reverse();

    const ctxAreaChart = areaChart.getContext('2d');
    const gradient = ctxAreaChart.createLinearGradient(0, 0, 0, 150);

    gradient.addColorStop(0, 'rgba(34, 181, 255, 1)');
    gradient.addColorStop(1, 'rgba(34, 181, 255, 0.2)');

    const chartArea = new Chart(ctxAreaChart, {
      type: 'line',
      data: {
          labels: labels,
          datasets: [{
            label: '',
            data: this.salesByPeriod,
            backgroundColor: gradient,
            pointRadius: 5,
            pointHoverRadius: 5,
            pointBackgroundColor: 'rgba(34, 181, 255, 1)',
            borderColor: 'rgba(34, 181, 255, 1)',
            borderWidth: 2
          }],
      },
      options: {
        elements: { line: { tension: 0 } },
        display: true,
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{ gridLines: { display: true }, ticks: { display: true, fontColor: '#777', padding: 15 } }],
          xAxes: [{ gridLines: { display: true }, ticks: { display: true, fontColor: '#777', padding: 15 } }]
        }
      }
    });
  }

  mountBarChart() {
    const barChart: any = document.getElementById('bar-chart');

    if (!barChart) { return; }

    const ctxBarChart = barChart.getContext('2d');
    const gradient = ctxBarChart.createLinearGradient(0, 0, 0, 200);

    gradient.addColorStop(0, 'rgba(142, 66, 255, 0.8)');
    gradient.addColorStop(1, 'rgba(34, 181, 255, 0.5)');

    const paymentsBar = new Chart(ctxBarChart, {
      type: 'bar',
      data: {
        labels: [
          this.months[new Date().getMonth() - 4],
          this.months[new Date().getMonth() - 3],
          this.months[new Date().getMonth() - 2],
          this.months[new Date().getMonth() - 1]
        ],
        datasets: [{
          data: [
            this.payments.fourthMonth,
            this.payments.thirdMonth,
            this.payments.secondMonth,
            this.payments.firstMonth
          ],
          backgroundColor: gradient,
          hoverBackgroundColor: gradient,
          hoverBorderWidth: 2,
          hoverBorderColor: 'purple',
          borderWidth: 0
        }]
      },
      options: {
        legend: { display: false },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{ gridLines: { display: true }, ticks: { display: true, fontColor: '#777', padding: 15 } }],
          yAxes: [{ gridLines: { display: true }, ticks: { display: true, fontColor: '#777', padding: 15 } }],
        }
      },
    });
  }

  getCurrentMonth() {
    const month = new Date().getMonth();
    return this.months[month];
  }

  getFormatedCurrency(value) {
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/visao-geral/visao-geral.component.ts